let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cT1O2")).then(() => parcelRequire('kI3My'));